import { useContext } from 'react'
import { useSnackbar } from 'notistack'

import BasicDialog from '../../../components/m3/basic-dialog'
import Api from '../../../utils/api'
import ContactsContext from '../context'

interface IProps {
  open: boolean
  handleClose: () => void
  userId: number
  closeUserDetailsDrawer: () => void
  selectedFolderId: number
}

const DeleteUserModal = (props: IProps) => {
  const { open, handleClose, userId, closeUserDetailsDrawer, selectedFolderId } = props

  const { enqueueSnackbar } = useSnackbar()

  const { getNotificationContacts } = useContext(ContactsContext)

  const handleDelete = async () => {
    Api.del(`/api/v2/protect/folders/${selectedFolderId}/notification-contacts/${userId}`).then((res) => {
      if (res.ok) {
        enqueueSnackbar('Contact has been deleted.')
        handleClose()
        closeUserDetailsDrawer()
        getNotificationContacts()
      } else {
        enqueueSnackbar('Could not delete contact', { variant: 'error' })
      }
    })
  }

  return (
    <BasicDialog
      title="Delete this contact?"
      showCloseIcon
      textContent="The contact will be permanently deleted from your account."
      open={open}
      onClose={handleClose}
      onConfirm={handleDelete}
      confirmLabel="Delete"
      closeLabel="Cancel"
    />
  )
}

export default DeleteUserModal
